<template>
  <div class="web-box-all">
    <ext-header></ext-header>

    <div class="web-home-main">

      <div class="web-order-box">
        <div class="web-order-left">
          <ext-nav></ext-nav>
        </div>
        <div class="web-order-right">

          <div class="web-order-title">
            <ul>
              <li class="select">
                <a>会员中心</a>
              </li>
            </ul>
          </div>

          <div class="web-vip-info">
            <div class="web-vip-info-card">
              <div class="app-user-vip-card-box app-user-vip-card-vip">
                  <div class="app-user-vip-card-h">{{store_name}}</div>
                  <div class="app-user-vip-card-p">积分</div>
                  <div class="app-user-vip-card-foot">
                      <div class="app-user-vip-card-foot-left">
                          <div class="app-user-vip-card-foot-left-a">{{user_integral}}</div>
                          <div class="app-user-vip-card-foot-left-b" v-if="vip_class!=1">/{{integral}}</div>
                      </div>
                      <div class="app-user-vip-card-foot-right" v-if="vip_class!=1">
                          <div class="app-user-vip-card-foot-right-txt">达到{{integral}}积分可升级vip会员</div>
                      </div>
                  </div>
                  <img v-if="vip_class==1" class="app-user-vip-icon" src="@/assets/vip_icon.png"/>
              </div>
            </div>
            <div class="web-vip-info-main">
              <p v-html="vip_nodes"></p>
            </div>
          </div>

        </div>
      </div>

    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import ExtNav from '@/components/leftnav/index'
import {getUserId, ajax} from '@/utils/extend'

export default {
  name: 'vip_info',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-nav': ExtNav
  },
  data () {
    return {
      title: '门店信息',
      user_info: {},
      vip_icon: '',
      store_name: '',
      user_integral: 0,
      integral: 0,
      vip_class: 0,
      vip_nodes: ''
    }
  },
  mounted () {
    this.load_user()
    this.load_data()
    this.load_html()
  },
  methods: {
    load_user () {
      var that = this
      ajax({
        url: '/store/user/user_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.store_name = ret.data.store_name
          that.user_integral = ret.data.integral
          that.vip_class = ret.data.vip_class
        } else {
          that.store_name = ''
          that.user_integral = 0
          that.vip_class = 0
        }
      })
    },
    load_data () {
      var that = this

      ajax({
        url: '/store/user/vip_info_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.integral = ret.data.integral
        } else {
          that.integral = 0
        }
      })
    },
    load_html () {
      var that = this

      ajax({
        url: '/store/user/vip_nodes',
        method: 'post',
        dataType: 'text',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        that.vip_nodes = ret
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-box { width:100%; height:auto; flex-flow:row; align-content:flex-start; margin-top:20px;}
  .web-order-left { width:200px; height:auto; margin-right:15px; flex-wrap:wrap; align-content:flex-start;}

  .web-order-right { width:785px; height:auto; flex-wrap:wrap; align-content:flex-start;}

    .web-order-title { width:100%; height:50px; border-bottom: 1px solid #dfdfdf;}
      .web-order-title ul { width:400px; height:50px; list-style:none; margin:0px; padding:0px; flex-wrap:wrap; align-content:flex-start;}
      .web-order-title ul li { width:80px; height:50px; cursor: pointer; line-height: 50px; font-size:14px; text-align: center;justify-content:center; }
      .web-order-title ul li a { color:#333333;}
      .web-order-title ul li a:hover { color:#d81e06; font-weight: bold;}
      .web-order-title ul li.select { border-bottom: 2px solid #d81e06;}
   .web-store-info { width:100%; min-height: 402px; flex-wrap:wrap; margin-top:15px; border:1px  solid #dfdfdf; align-content:flex-start;}
      .web-store-info ul { width:100%; height: auto; list-style:none; margin-top:15px; flex-wrap:wrap; align-content:flex-start;}
      .web-store-info ul li { width:100%; height:40px; flex-flow:row; align-content:flex-start;}
      .web-store-info ul li a { width:80px; height:40px; line-height:40px; font-size:14px; color:#333333;}
      .web-store-info ul li p { width:auto; height:40px; line-height:40px; font-size:12px; color:#333333;}

  .web-vip-info { width:100%;  min-height: 435px; flex-wrap:wrap; align-content:flex-start;margin-top:15px; padding:0px 15px; border:1px  solid #dfdfdf; align-content:flex-start;}
    .web-vip-info-card { width:100%; height:auto; margin-top:15px;}
    .web-vip-info-main { width:100%; height:auto; margin-top:15px; }

      .app-user-vip-top-box { width:300px; height: auto; margin-top:10px; padding:0px 15px; flex-wrap:wrap; align-content:flex-start; box-sizing: border-box;}
    .app-user-vip-card-box {  width:300px; height: 120px; border-radius: 10px; flex-wrap:wrap; align-content:flex-start; position: relative; background:rgb(244, 207, 137); padding:10px 25px; box-sizing: border-box;}
    .app-user-vip-card-vip { background:rgb(220, 40, 30);}
    .app-user-vip-icon { width:50px; height:50px; position: absolute; right:10px; top:30px;}
        .app-user-vip-card-h { width:100%; height:30px; line-height: 30px; overflow: hidden; font-size:18px; color:#ffffff; font-weight: bold;}
        .app-user-vip-card-p { width:100%; height:20px; line-height: 20px; font-size:12px; color:#ffffff; margin-top:10px;}
        .app-user-vip-card-foot { width:100%; height:50px; flex-direction: row;justify-content:space-between; margin-top:5px; margin-left:-3px;}
            .app-user-vip-card-foot-left { width:auto; height: 50px;flex-direction: row;}
                .app-user-vip-card-foot-left-a { width:auto; height: 50px; line-height: 30px; font-size: 38px; color:#ffffff;}
                .app-user-vip-card-foot-left-b { width:auto; height: 50px; line-height: 50px; font-size: 12px; color:#ffffff;}
            .app-user-vip-card-foot-right { width:auto; height: auto;}
                .app-user-vip-card-foot-right-txt { width:auto; height: 50px; line-height: 50px; font-size: 12px; color:#ffffff;}
.app-user-vip-main-box { width:100%; height: auto;}
    .app-user-vip-main-title { width:100%; height: 40px; padding:0px 15px; box-sizing: border-box; margin-top:10px;}
        .app-user-vip-main-title-txt { width:100%; height: 40px; line-height: 40px; font-size: 15px; color:#333333;}
    .app-user-vip-main-remark { width:100%; height: auto; padding:0px 15px; box-sizing: border-box;}
        .app-user-vip-main-remark-txt { width:100%; height: auto; line-height: 20px; font-size: 12px; color:#333333; padding:0px;}

</style>



// WEBPACK FOOTER //
// src/pages/store/vip_info.vue